const usagePath = '/usage';
export default usagePath;
